module.exports = __webpack_public_path__ + "img/nandu-roof-photo.93a16db4.jpg";